/* eslint-disable */
export const region5Barangays = [
    {
        CITY: 'AROROY',
        BARANGAY: 'AMBOLONG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'AMOROY',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'AMUTAG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'BAGAUMA',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'BALAWING',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'CABAS-AN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'CALANAY',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'CAPSAY',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'DON PABLO DELA ROSA',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'GUMAHANG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'JABOYOAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'LANANG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'LUY-A',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MACABUG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MALUBI',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MANAGANAGA',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MANAMOC',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MARIPOSA',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MATABA',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MATALANGTALANG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'MATANGOG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'NABONGSORAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'PANGLE',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'PANIQUE',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'PINANAAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'PURO',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'SYNDICATE',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'TALABAAN',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'TALIB',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'AROROY',
        BARANGAY: 'TINIGBAN',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'BAAO',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'BANASE',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'BATUILA',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'CAGARA',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'CAGPANDAN',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'CANCAHORAO',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'CANJUNDAY',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'DOCOL',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'EASTERN CAPSAY',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'GANGAO',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'LAGTA',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'LAHONG INTERIOR',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'LAHONG PROPER',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'MADANGCALAN',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'MANOBOC',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'OBONGON DIOT',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'POLOT',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'POTOSON',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'SOG-ONG',
    },
    {
        CITY: 'BALENO',
        BARANGAY: 'TINAPIAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'BAYBAY (LUMOCAB)',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'BONGCANAWAY',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'CANTIL',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'CASAMONGAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'GUINBANWAHAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'JANGAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'JINTOTOLO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'MABUHAY (BONGCANAWAY III)',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'MAPILI',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'MAPITOGO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'PALANE',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'PANGUIRANAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'PANUBIGAN',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'POBLACION (BALUD)',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'PULANDUTA',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'QUINAYANGAN DIOTAY',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'QUINAYANGAN TONGA',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'SAMPAD',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'SAN ANDRES (QUINAYANGAN DACU)',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'SAPATOS',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'TONGA',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'UBO',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'VICTORY (VICTORIA)',
    },
    {
        CITY: 'BALUD',
        BARANGAY: 'VILLA ALVAREZ',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'AGUADA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'CADULAWAN',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'CAGBATANG',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'CHIMENEA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'CURVADA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'DOMOROG',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'ESTAMPAR',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'GAHIT',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MAANAHAO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MADAMBA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MATAYUM',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MATUBINAO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'MINTAC',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'NADAWISAN',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'PAWICAN',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'TAGBOAN',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'TUYBO',
    },
    {
        CITY: 'CATAINGAN',
        BARANGAY: 'VILLA POGADO',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'BEGIA',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'CABAYUGAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'CALAPAYAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'CHICO ISLAND',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'DALIPE',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'GILOTONGAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'GUIOM',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'IRAYA',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'ITOMBATO',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'LAGUE-LAGUE',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'MACTAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'MADBAD',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'MAIHAO',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'MALBUG',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'NARO',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PALOBANDERA',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PANANAWAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PENA ISLAND',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PIN-AS',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PULOT',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'PUNTA BATSAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'R.M. MAGBALON (BEBINAN)',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'RECODO',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'TABERNA',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'TUBOG',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'CAWAYAN',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'BALANTAY',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'BALOCAWE',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'BUENAFLOR',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'BURACAN',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'CABANOYOAN',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'CABRERA',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'CADULAN',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'CALABAD',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'CANOMAY',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'GAID',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'GREGORIO ALINO (PIA-ONG)',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'MAGCARAGUIT',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'DIMASALANG',
        BARANGAY: 'T.R. YANGCO (YANCO)',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'ALAS',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'AYAT',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'BAT-ONGAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'BUGTONG',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'CABITAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'CAGMASOSO',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'CANOMOY',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'DAYAO',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'GUINCAIPTAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'LAGUINBANWA',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'LANTANGAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'MABATOBATO',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'MAOLINGON',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'NAILABAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'NANIPSAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'PINAMANGCAAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'POLO DACU',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'TAGPU',
    },
    {
        CITY: 'MANDAON',
        BARANGAY: 'TUMALAYTAY',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'CAMBANEZ',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'CANARES',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'COSTA RICA',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'GIBRALTAR',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'MATABAO',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'NASANDIG',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'PANISIHAN',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'ROYROY',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'ANAS',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'ASID',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'B. TITONG',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BAPOR (POB.)',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BATUHAN',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BAYOMBON',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BIYONG',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'CAWAYAN EXTERIOR',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'CAWAYAN INTERIOR',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'ESPINOSA',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'F. MAGALLANES',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'IBINGAY',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'KALIPAY (POB.)',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'KINAMALIGAN',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'MALINTA',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'MAPINA',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'MAYNGARAN',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'NURSERY',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'PATING (POB.)',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'SINALONGAN',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'TUGBO',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'UBONGAN DACU',
    },
    {
        CITY: 'MASBATE',
        BARANGAY: 'USAB',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'ALBASAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BOCA ENGANO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CALPI',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CANOMAY',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MABABANG BAYBAY',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MABITON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MANAPAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'NABASAGAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'NONOC',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PASIG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'POBLACION DISTRICT I (BGY. 1)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'POBLACION DISTRICT II (BGY. 2)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAGUILID',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'AGOHO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ALMERO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'DOMOROG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ILIGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LABANGTAYTAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LABRADOR',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MASBARANON',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'POTINGBATO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SOROSIMBAJAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TAWAD',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TUNGA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'VILLA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'AGUADA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'BAN-AO',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'CAMAYABSAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'DAANLUNGSOD',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'DANGPANAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'DARAGA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'GUIN-AWAYAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'GUINHAN-AYAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'LOCSO-AN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MANLUT-OD',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MATAGANTANG',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'NABOCTOT',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'NAGARAO',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'NAINDAY',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'NAOCONDIOT',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'PASIAGON',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'PURO',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'QUIBRADA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'TAVERNA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'VILLA INOCENCIO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ALTAVISTA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BAYANIHAN POB. (DISTRICT 4)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BAYBAYDAGAT POB. (DISTRICT 1)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BENITINAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUENOS AIRES',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CANELAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CORBADA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DAPLIAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LAHONG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAGKAIPIT',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAGSASAKA POB. (DISTRICT 3)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MINIO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PINAMOGHAAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'RESURRECCION',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SILANGAN POB. (DISTRICT 2)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SOWA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'VALPARAISO',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'ALMINE',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BAGAHANGLAD',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BARTOLABAC',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'CALIPAT-AN',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'DORONG-AN DAPLIAN',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'INTERIOR',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'JAGNA-AN',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'ROOSEVELT',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'WASHINGTON',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BOCA CHICA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BOLOD (POB.)',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BUSING',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'CUEVA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'DANGCALAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'HALABANGBAYBAY',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'INIWARAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'KI-BUAYA (RIZAL)',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'KI-ROMERO (ROXAS)',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'LAURENTE',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MALAKING ILOG',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MAPANIQUE',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'NAZARENO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'PINAMASINGAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'QUINTINA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'TERRAPLIN (POB.)',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'BANGAD',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'BARA',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'CALASUCHE',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'CALUMPANG (TAISAN)',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'CAPACULAN',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'CAYABON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'GUINLUTHANGAN',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'JAMORAWON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'MAGSALANGI',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'MATAGBAC',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'MATANGLAD',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'MATIPORON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'MOISES R. ESPINOSA',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'NARANGASAN',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'PAMANGPANGON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'PARAISO (POTOT)',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'SAWMILL',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'TAGBON',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'TAWAD',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'MILAGROS',
        BARANGAY: 'TINACLIPAN (BATO)',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'BAANG',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'BALATUCAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'BARAG',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'DACU',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'GUINTORELAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'HOLJOGON',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'LALAGUNA',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'LOMOCLOC',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'LUYONG CATUNGAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'MANDALI',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'MAPUYO',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'MARINTOC',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'NASUNDUAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'PINAMALATICAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'PINAMARBUHAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'POBLACION DIST. I',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'POBLACION DIST. II',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'POLOT',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'SAWMILL',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'TABUC',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'TUGAWE',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'TUGBO',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'UMABAY EXTERIOR',
    },
    {
        CITY: 'MOBO',
        BARANGAY: 'UMABAY INTERIOR',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'CANTORNA',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'FAMOSA',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'GUINHADAP',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'MAGLAMBONG',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'MOROCBOROCAN',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MONREAL',
        BARANGAY: 'TOGORON',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'BANCO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'BIGA-A',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'BONTOD',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'INTUSAN',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'JOSE A. ABENIR SR. (LIBTONG)',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MAANAHAO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MALATAWAN',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MALIBAS',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MARAVILLA',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MATUGNAO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'MIABAS',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'NABANGIG',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'NIPA',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'PARINA',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'PINNA',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PALANAS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'BUGANG',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'BUGTONG',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'BUNDUCAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'CABANGRAYAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'CALONGONGAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'CASABANGAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'GUINDAWAHAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'LABIGAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'LAMPUYANG',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'PALHO',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'TANQUE',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'PIO-V.-CORPUZ',
        BARANGAY: 'TUBOG',
    },
    {
        CITY: 'USON',
        BARANGAY: 'ARADO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'ARMENIA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'BADLING',
    },
    {
        CITY: 'USON',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'USON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'CAMPANA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'CROSSING',
    },
    {
        CITY: 'USON',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'USON',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'USON',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MADAO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MARCELLA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MIAGA',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MONGAHAY',
    },
    {
        CITY: 'USON',
        BARANGAY: 'MOROCBOROCAN',
    },
    {
        CITY: 'USON',
        BARANGAY: 'PAGUIHAMAN',
    },
    {
        CITY: 'USON',
        BARANGAY: 'PANICIJAN',
    },
    {
        CITY: 'USON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'USON',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'USON',
        BARANGAY: 'SIMAWA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'AWANG',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BAGATANGKI',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BALADING',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BALZA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BARIW',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BULANG',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'CABUNTURAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'COMUN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'DIARO',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'ESTANCIA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'JONOP',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'LIBOD',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'MALOLOS',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'MATALIPNI',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'OGOB',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'PAYAHAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'QUINARABASAHAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SOA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SUGCAD',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'TAGOYTOY',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'TULIW',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'ALIMSOG',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BAGONG SAN ROQUE',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BUHATAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CALAYUCAY',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'DEL ROSARIO POB. (BGY. 3)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'FIDEL SURTIDA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'LIDONG',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MARKET SITE POB. (BGY. 9)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NAGSIYA POB. (BGY. 8)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PANDAYAN POB. (BGY. 10)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN FRANCISCO POB. (BGY. 1)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN JUAN POB. (BGY. 2)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN PEDRO POB. (BGY. 5)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN RAFAEL POB. (BGY. 7)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN VICENTE POB. (BGY. 6.)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTA MISERICORDIA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTO DOMINGO POB. (BGY. 4)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BACLAYON',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BARIW',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BAYANDONG',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BONGA (UPPER)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BUANG',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'BUSDAC (SAN JOSE)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'CABASAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'CAGBULACAO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'CAGRARAY',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'CAJOGUTAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'DAMACAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'GUBAT ILAWOD',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'GUBAT IRAYA',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'HINDI',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'LANGATON',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'MANAET',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'MAPULANG DAGA',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'MATAAS',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'MISIBIS',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'NAHAPUNAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'NAMANDAY',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'NAMANTAO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'NAPAO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'PANARAYON',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'PIGCOBOHAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'PILI ILAWOD',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'PILI IRAYA',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'PONGCO (LOWER BONGA)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'SOGOD',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'SULA',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'TAMBILAGAO (TAMBOGNON)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'TAMBONGON (TAMBILAGAO)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'TANAGAN',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'USON',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'VINISITAHAN-BASUD (MAINLAND)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'VINISITAHAN-NAPAO (ISLAND)',
    },
    {
        CITY: 'BACACAY',
        BARANGAY: 'VINISITAHAN-NAPAO (LSLAND)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'ANOLING',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BALIGANG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BANTONAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BARIW',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BINANDERAHAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BINITAYAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'BONGABONG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'CABAGNAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'CABRARAN PEQUENO',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'CAGUIBA',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'CALABIDONGAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'COMUN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'COTMON',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'GAPO',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'GOTOB',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'ILAWOD',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'ILULUAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'LIBOD',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'LIGBAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MAGOGON',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MANAWAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MANINILA',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MINA',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'MITI',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'PALANOG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'PANOYPOY',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'PARIAAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'QUINARTILAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'QUIRANGAY',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'QUITINDAY',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'SALUGAN',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'SOLONG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'SUMLANG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TAGOYTOY',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TALADONG',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TALOTO',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TAPLACON',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'CAMALIG',
        BARANGAY: 'TUMPA',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'ALCALA',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'ALOBO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BALINAD',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BANADERO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BANAG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BASCARAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BIGAO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BINITAYAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BONGALON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BUDIAO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'CANAROM',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'CANARON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'CULLAT',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'DINORONAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'GABAWAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'GAPO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'IBAUGAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'ILAWOD AREA POB. (DIST. 2)',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'INARADO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'KIDACO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'KILICAO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'KIMANTONG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'KINAWITAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'KIWALO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'LACAG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MALABOG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MAOPI',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MARKET AREA POB. (DIST. 1)',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MAROROY',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MATNOG',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MAYON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'MI-ISI',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'NABASAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'NAMANTAO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAGPON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAN VICENTE GRANDE',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SAN VICENTE PEQUENO',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'SIPI',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'TABON-TABON',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'TAGAS',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'TALAHIB',
    },
    {
        CITY: 'DARAGA',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'AGPAY',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BATBAT',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BINOGSACAN LOWER',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BINOGSACAN UPPER',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BOLOLO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'BUBULUSAN',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'CATOMAG',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'DONA MERCEDES',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'DONA TOMASA (MAGATOL)',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'ILAWOD',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'INAMNAN GRANDE',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'INAMNAN PEQUENO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'INASCAN',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'IRAYA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'LOMACAO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MAGUIRON',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MAIPON',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MALABNIG',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MALIPO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MANINILA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MAPACO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MARCIAL O. RANOLA (CABALOAON)',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MASARAWAG',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MAURARO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MINTO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MORERA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MULADBUCAD GRANDE',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'MULADBUCAD PEQUENO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'ONGO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'POOD',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'QUIBONGBONGAN',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'QUITAGO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'SAN JOSE (OGSONG)',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'SINUNGTAN',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'TANDARORA',
    },
    {
        CITY: 'GUINOBATAN',
        BARANGAY: 'TRAVESIA',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'AURORA POB. (BGY. 6)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'CABRARAN',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'CALZADA POB. (BGY. 7)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'FLORISTA',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'MABINI POB. (BGY. 2)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'MAGSAYSAY POB (BGY. 4)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'MAMLAD',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'MAOGOG',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'MERCADO POB. (BGY. 5)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'PLAZA POB. (BGY. 3)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'QUITINDAY POB. (BGY. 8)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'RIZAL POB. (BGY. 1)',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'SINAGARAN',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'JOVELLAR',
        BARANGAY: 'WHITE DEER POB. (BGY. 9)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 1 - EM\'S BARRIO (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 1 - EM\'S BARRIO(POB)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 10 - CABUGAO',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 11 - MAOYOD POB. (BGY. 10 & 11)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 11 - MAOYOD POB. (BGY. 10 AND 11)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 12 - TULA-TULA (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 13 - ILAWOD WEST POB. (ILAWOD 1)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 14 - ILAWOD POB. (ILAWOD 2)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 15 - ILAWOD EAST POB. (ILAWOD 3)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 16 - KAWIT-EAST WASHINGTON DRIVE (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 17 - RIZAL SREET.',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 17 - RIZAL SREET. ILAWOD (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 18 - CABAGNAN WEST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 19 - CABAGNAN',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 2 - EM\'S BARRIO SOUTH (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 2 - EM\'S BARRIO SOUTH(POB)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 20 - CABAGNAN EAST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 21 - BINANUAHAN WEST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 22 - BINANUAHAN EAST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 23 - IMPERIAL COURT SUBD. (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 24 - RIZAL STREET',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 25 - LAPU-LAPU (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 26 - DINAGAAN (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 27 - VICTORY VILLAGE SOUTH (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 28 - VICTORY VILLAGE NORTH (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 29 - SABANG (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 3 - EM\'S BARRIO EAST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 3 - EM\'S BARRIO EAST (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 3 - EM\'S BARRIO EAST(POB)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 30 - PIGCALE (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 31 - CENTRO-BAYBAY (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 32 - SAN ROQUE (BGY. 66)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 33 - PNR-PENARANDA ST.- IRAYA (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 33 - PNR-PENARANDA ST.-IRAYA (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 34 - ORO SITE-MAGALLANES ST. (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 35 - TINAGO (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 36 - KAPANTAWAN (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 37 - BITANO (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 38 - GOGON (BGY. 54)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 39 - BONOT (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 4 - SAGPON POB. (SAGPON 1)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 40 - CRUZADA (BGY. 52)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 41 - BOGTONG (BGY. 45)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 42 - RAWIS (BGY. 65)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 43 - TAMAOYAN (BGY. 67)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 44 - PAWA (BGY. 61)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 45 - DITA (BGY. 51)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 46 - SAN JOAQUIN (BGY. 64)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 47 - ARIMBAY',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 48 - BAGONG ABRE (BGY. 42)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 49 - BIGAA (BGY. 44)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 5 - SAGMIN POB. (SAGPON 2)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 50 - PADANG (BGY. 60)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 51 - BUYUAN (BGY. 49)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 52 - MATANAG',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 53 - BONGA (BGY. 48)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 54 - MABINIT (BGY. 59)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 55 - ESTANZA (BGY. 53)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 56 - TAYSAN (BGY. 68)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 57 - DAP-DAP (BGY. 69)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 58 - BURAGWIS',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 59 - PURO (BGY. 63)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 6 - BANADERO POB. (SAGPON 3)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 60 - LAMBA',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 61 - MASLOG (BGY. 58)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 62 - HOMAPON (BGY. 55)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 63 - MARIAWA (BGY. 56)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 64 - BAGACAY (BGY. 41 BAGACAY)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 64 - BAGACAY (BGY. 41 BAGACAY)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 65 - IMALNOD (BGY. 57)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 65 - IMALNOD (BGY. 57)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 66 - BANQUEROHAN (BGY. 43)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 67 - BARIIS (BGY. 46)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 68 - SAN FRANCISCO (BGY. 62)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 69 - BUENAVISTA (BGY.47)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 7 - BANO (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 70 - CAGBACONG (BGY. 50)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 8 - BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'LEGAZPI',
        BARANGAY: 'BGY. 9 - PINARIC (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ALONGONG',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'APUD',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BARIW',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BUGA',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BULUSAN',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'CAGUSCOS',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'EAST CARISAC',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'HARIGUE',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MABAYAWAS',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MACABUGOS',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MAGALLANG',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MALABIGA',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MARAYAG',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MATARA',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'MOLOSBOLOS',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'NATASAN',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'NINO JESUS (SANTO NINO JESUS)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'NOGPO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAMPONGAN',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'TALIN-TALIN',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'VILLA PETRONA',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'WEST CARISAC',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE VI (POB.)',
    },
    {
        CITY: 'LIBON',
        BARANGAY: 'ZONE VII (POB.)',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'ABELLA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'ALLANG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'AMTIC',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BALANAC',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BALIGANG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BASAG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BAY',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BINANOWAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BINATAGAN (POB.)',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BOBONSURAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BUSAC',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'CABARIAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'CALZADA (POB.)',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'CATBURAWAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'CAVASI',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'CULLIAT',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'DUNAO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'FRANCIA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'GUILID',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'HERRERA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'LAYON',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'MACALIDONG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'MAHABA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'MALAMA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'MAONON',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'NABONTON',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'NASISI',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'OMA-OMA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PALAPAS',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PAULBA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PAULOG',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PINAMANIQUIAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'PINIT',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'RANAO-RANAO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TAGPO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TANDARORA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TANDARURA',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TASTAS',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TINAMPO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TIONGSON',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TOMOLIN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TULA-TULA GRANDE',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TULA-TULA PEQUENO',
    },
    {
        CITY: 'LIGAO',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'BINITAYAN',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'CALBAYOG',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'CANAWAY',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN ANTONIO SANTICON (POB.)',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN ANTONIO SULONG',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN ISIDRO ILAWOD',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN ISIDRO IRAYA',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MALILIPOT',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'BALABAGON',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'BALASBAS',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'CABACONGAN',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'CABIT',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'HOLUGAN',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'IT-BA (POB.)',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'MANUMBALAY',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'NAGOTGOT',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'MANITO',
        BARANGAY: 'TINAPIAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BADBAD',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BADIAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BAGSA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BANGIAWON',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BOGTONG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BONGORAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'BUSAC',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CADAWAG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CAGMANABA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CALAGUIMIT',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CALPI',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CASINAGAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'CENTRO POBLACION',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'COLIAT',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'GUMABAO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'ILAOR NORTE',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'ILAOR SUR',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'IRAYA NORTE',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'IRAYA SUR',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MAPORONG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MARAMBA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MATAMBO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MAYAG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MAYAO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'MOROPONROS',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'NAGAS',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'OBALIW-RINAS',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'PISTOLA',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'RAMAY',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SABAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN PASCUAL (NALE)',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'SAN VICENTE (SUCA)',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TABLON',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TALONGOG',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TAPEL',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TOBGON',
    },
    {
        CITY: 'OAS',
        BARANGAY: 'TOBOG',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'AGOL',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'ALABANGPURO',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BANAWAN (BINAWAN)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BASICAO COASTAL',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BASICAO INTERIOR',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BINODEGAHAN',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'CARATAGAN',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'CUYAOYAO',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'LA MEDALLA',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'LAWINON',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MACASITAS',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MALAPAY',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MALIDONG',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MAMLAD',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MARIGONDON',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'MATANGLAD',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'NABLANGBULOD',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'ORINGON',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'PALAPAS',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'PANGANIRAN',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'SUKIP',
    },
    {
        CITY: 'PIO-DURAN',
        BARANGAY: 'TIBABO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'AGOS',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'ALNAY',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'ALOMON',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'AMOGUIS',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'ANOPOL',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'APAD',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BALABA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BALANGIBANG',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BALINAD',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BINAGBANGAN (PINTOR)',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'CENTRO OCCIDENTAL (POB.)',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'CENTRO ORIENTAL (POB.)',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'CEPRES',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'COTMON',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'COTNOGAN',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'GABON',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'GAMOT',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'ITARAN',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'KINALE',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'KINUARTILAN',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'LA MEDALLA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'LANIGAY',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'LIDONG',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MAGPANAMBO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MAGURANG',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MATACON',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MAYNAGA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MAYSUA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'MENDEZ',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'PINAGDAPUGAN',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'PONSO',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SANTICON',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'SUGCAD',
    },
    {
        CITY: 'POLANGUI',
        BARANGAY: 'UBALIW',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BAGAOBAWAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BATAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BILBAO',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BINOSAWAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BOGTONG',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'BUHATAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'CALANAGA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'CARACARAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'CAROGCOG',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'DAP-DAP',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'GABA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'GALICIA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'HAMORAWON',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'LIGUAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MANANAO',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MANCAO',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MANILA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MASAGA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'MOROCBOROCAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'NAGCALSOT',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'PAGCOLBON',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'TINOCAWAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'TINOPAN',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'RAPU-RAPU',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'AGNAS (SAN MIGUEL ISLAND)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BANGKILINGAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BARANGHAWON',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BASAGAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BASUD (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BOGNABONG',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BOMBON (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BONOT',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BUANG',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'BUHIAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'CABAGNAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'COBO',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'COMON',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'CORMIDAL',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'DIVINO ROSTRO (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'GUINOBAT',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'HACIENDA (SAN MIGUEL ISLAND)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'MAGAPO',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'MARIROC',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'MATAGBAC',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'ORAS',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'OSON',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'PANAL',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'PINAGBOBONG',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'QUINALE CABASAN (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'QUINASTILLOJAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'RAWIS (SAN MIGUEL ISLAND)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAGURONG (SAN MIGUEL ISLAND)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN ISIDRO (BORING)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SANTO CRISTO (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'SUA-IGOT',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'TABIGUIAN',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'TAGAS',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'TAYHI (POB.)',
    },
    {
        CITY: 'TABACO',
        BARANGAY: 'VISITA (SAN MIGUEL ISLAND)',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BARIIS',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BELEN (MALABOG)',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BIYONG',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'CALE',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'CARARAYAN',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'CORO-CORO',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'DAP-DAP',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'GAJO',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'JOROAN',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'MATALIBONG',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'MAYNONONG',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'MAYONG',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'MISIBIS',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'NAGAS',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'OYAMA',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'PUTSAN',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'SAN BERNARDO',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'SOGOD',
    },
    {
        CITY: 'TIWI',
        BARANGAY: 'TIGBI (POB.)',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'ANGAS',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'BACTAS',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'BINATAGAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'CAAYUNAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'GUINATUNGAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'HINAMPACAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'LANGA',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'LANITON',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'LIDONG',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MAMPILI',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MANDAZO',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MANGCAMAGONG',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MANMUNTAY',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MANTUGAWE',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MATNOG',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'MOCONG',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'OLIVA',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'PINAGWARASAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'TABA-TABA',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'TACAD',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'TAISAN',
    },
    {
        CITY: 'BASUD',
        BARANGAY: 'TUACA',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'APUAO',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY VII (POB.)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'CARINGO',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'CATANDUNGANON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'CAYUCYUCAN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'COLASI',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'DEL ROSARIO (TAGONGTONG)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'GABOC',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'HAMORAON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'HINIPAAN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'LALAWIGAN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'LANOT',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'MAMBUNGALON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'MANGUISOC',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'MASALONGSALONG',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'MATOOGTOOG',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'PAMBUHAN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'QUINAPAGUIAN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'TARUM',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'ASDUM',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'CALABAGAS',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'IRAYA SUR',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'MAN-OGOB',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'POBLACION DISTRICT I (SILANGAN/BGY. 1)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'POBLACION DISTRICT II (KANLURAN/BGY. 2)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SAN JOSE (IRAYA NORTE)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BINANUAAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CAAWIGAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CAHABAAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CALINTAAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'GABON',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ITOMANG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'ALAYAO',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'BINAWANGAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'CALABACA',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'CAMAGSAAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'CATABAGUANGAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'CATIOAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'ITOK',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'LUCBANAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'MACTANG',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'MATAQUE',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'OLD CAMP',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'UBANG',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'CAPALONGA',
        BARANGAY: 'VILLA BELEN',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'ALAWIHAO',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'AWITAN',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BAGASBAS',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY VII (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BARANGAY VIII (POB.)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BIBIRAO',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'BORABOD',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'CALASGASAN',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'COBANGBANG (CARUMPIT)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'DOGONGAN',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'GAHONON',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'GUBAT',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'LAG-ON',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'MAGANG',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'MAMBALITE',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'MANCRUZ (MANGCRUZ)',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'PAMORANGON',
    },
    {
        CITY: 'DAET',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'BAGONG BAYAN',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'CALERO',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'DAHICAN',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'LARAP',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'LUKLUKAN NORTE',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'LUKLUKAN SUR',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'MOTHERLODE',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'NAKALAYA',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SANTA MILAGROSA',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SANTA ROSA NORTE',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SANTA ROSA SUR',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'JOSE-PANGANIBAN',
        BARANGAY: 'TAMISAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'ANAHAW (POB.)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'ANAMEAM',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'AWITAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAAY',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAGONG SILANG I',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAGONG SILANG II',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAGONG SILANG III (SILANG)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAKIAD',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BAYAN-BAYAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BENIT',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'BULHAO',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'CABATUHAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'CABUSAY',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'CALABASA',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'CANAPAWAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'DAGUIT',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'DALAS',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'DUMAGMANG',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'EXCIBAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'FUNDADO',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'GUINACUTAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'GUISICAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'GUMAMELA (POB.)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'IBERICA',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'KALAMUNDING (POB.)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'LUGUI',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MABILO I',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MABILO II',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MACOGON',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MAHAWAN-HAWAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MALANGCAO-BASUD',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MALASUGUI',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MALATAP',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MAOT',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MASALONG',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'MATANLANG',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'NAPAOD',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'PINYA (POB.)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'SUBMAKIN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'TALOBATIB',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'TIGBINAN',
    },
    {
        CITY: 'LABO',
        BARANGAY: 'TULAY NA LUPA',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'AWITAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'BAKAL',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'BATOBALANI',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'CALABURNAY',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'CASALUGAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'DAGANG',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'DALNAC',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'DANCALAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'GUMAUS',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MACOLABO ISLAND',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MALACBANG',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MALAGUIT',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MAMPUNGO',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MANGKASAY',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'MAYBATO',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'PINAGBIRAYAN MALAKI',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'PINAGBIRAYAN MUNTI',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'TABAS',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'TALUSAN',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'TAWIG',
    },
    {
        CITY: 'PARACALE',
        BARANGAY: 'TUGOS',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'DACULANG BOLO',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'DAGOTDOTAN',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'LANGGA',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'LANITON',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'MAISOG',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'MAMPUROG',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'MANLIMONSITO',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'MATACONG (POB.)',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-LORENZO-RUIZ',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'BASIAD',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'DON TOMAS',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'GUITOL',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'KABULUAN',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'KAGTALABA',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'MAULAWIN',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'PATAG IBABA',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'PATAG IRAYA',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'POLUNGGUITGUIT',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'SANTA ELENA (POB.)',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'SANTA-ELENA',
        BARANGAY: 'VILLA SAN ISIDRO',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'AGUIT-IT',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'BANOCBOC',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'CAGBALOGO',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'CALANGCAWAN NORTE',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'CALANGCAWAN SUR',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'GUINACUTAN',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'MANGCAWAYAN',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'MANGCAYO',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'MANLUCUGAN',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'MATANGO',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'NAPILIHAN',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'PINAGTIGASAN',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'SINGI',
    },
    {
        CITY: 'VINZONS',
        BARANGAY: 'SULA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'AGDANGAN',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'AGDANGAN POB. (SAN CAYETANO)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'BULUANG (SAN ANTONIO)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'CARANDAY (LA PURISIMA)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'CRISTO REY',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'DEL ROSARIO (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'IYAGAN',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'LA MEDALLA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'NABABARERA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'PUGAY (SAN RAFAEL)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN RAFAEL (IKPAN)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN RAMON (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SANTA EULALIA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SANTA TERESA (VIGA)',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'BAAO',
        BARANGAY: 'TAPOL',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'CABUNGAN',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'CAMANGAHAN (CAORASAN)',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'CAYOGCOG',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'COGUIT',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'DURAN',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'LAGANAC',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'LULUASAN',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'MONTENEGRO (MAGUIRON)',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'PARARAO',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'PULANG DAGA',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'SAGRADA NACACALE',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'SANTIAGO NACACALE',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'SIRAMAG (POB.)',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'TAPAYAS',
    },
    {
        CITY: 'BALATAN',
        BARANGAY: 'TOMATARAYO',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'PAGAO (SAN JUAN)',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BOMBON',
        BARANGAY: 'SIEMBRE',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'AMLONGAN (DEL ROSARIO)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'BUROCBUSOC',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'CAGMASLOG',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'DE LA FE',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'DELOS ANGELES (LOS ANGELES)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'DIVINO ROSTRO',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'GABAS',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'IBAYUGAN',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'IGBAC',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'IPIL (FATIMA)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'IRAYA (DEL ROSARIO)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'LABAWON (SANTA TERESITA)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'LOURDES (SANTA LOURDES)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'MACAANGAY',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'MONTE CALVARIO',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'NAMURABOD',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN BUENAVENTURA (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN FRANCISCO (PARADA)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN JOSE BAYBAYON',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN JOSE SALAY',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN PASCUAL (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SANTA CLARA (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SANTA ELENA (POB.)',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'SANTA JUSTINA',
    },
    {
        CITY: 'BUHI',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'BAGOLADIO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'BALAOGAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'CAORASAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'CASUGAD',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'CAUSIP',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'INOYONAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'ITANGON',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'KINALABASAHAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'LANIPGA',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'LUBGAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'OMBAO HEIGHTS',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'OMBAO POLPOG',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'PALSONG',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'PANOYPOYAN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'PAWILI',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAGRADA (SAGRADA FAMILIA)',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SALVACION (POB.)',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SAN ROQUE HEIGHTS',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BULA',
        BARANGAY: 'TAISAN',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'BARCELONITA',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'BIONG',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'NEW POBLACION',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CABUSAO',
        BARANGAY: 'SANTA LUTGARDA (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BALATASAN',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BALOMBON',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BALONGAY',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BIGAAS',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BINALIW',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BINANUAANAN GRANDE',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BINANUAANAN PEQUENO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BONOT-SANTA ROSA',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'CAGSAO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'CAMUNING',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'COMAGUINGKING',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'DOMINOROG',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'HAROBAY',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'LUGSAD',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'MANGUIRING',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'PAGATPAT (SAN JOSE)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'PAOLBO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'PINADA',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'PUNTA TARAWAL',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'QUINALE',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SALVACION-BAYBAY',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN ANTONIO (QUIPAYO)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN ANTONIO POBLACION',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN BERNARDINO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN LUCAS',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN PABLO (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTA CRUZ POBLACION',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTA CRUZ RATAY',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTA ISABEL (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTA SALUD (POB.)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SANTO NINO (QUIPAYO)',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SIBA-O',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SIBOBO',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'SOGOD',
    },
    {
        CITY: 'CALABANGA',
        BARANGAY: 'TOMAGODTOD',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'DUGCAL',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'MARUPIT',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN JOSE-SAN PABLO (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN JUAN-SAN RAMON (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN LUCAS (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN MARCOS (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN MATEO (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SANTO DOMINGO (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SANTO TOMAS (POB.)',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'CAMALIGAN',
        BARANGAY: 'TAROSANAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'AGOS',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BULUANG',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CARICOT',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CAWACAGAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'COTMON',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CRISTO REY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DIVINA PASTORA (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'GOYUDAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'LOBONG',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'LUBIGAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MANGA (MANGGA)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MASOLI',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'NEIGHBORHOOD',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'NINO JESUS',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PAGATPATAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PALO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PAYAK',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAGRADA (SAGRADA FAMILIA)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN RAFAEL (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SANTIAGO (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SOOC',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TAGPOLO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TRES REYES (POB.)',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'ABELLA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BAGUMBAYAN NORTE',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BAGUMBAYAN SUR',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BALATAS',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CALAUAG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CARARAYAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CAROLINA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CONCEPCION GRANDE',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CONCEPCION PEQUENO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'DAYANGDANG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'DINAGA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'IGUALDAD INTERIOR',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LERMA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LIBOTON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'MABOLO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'PACOL',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'PANICUASON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TABUCO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TRIANGULO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CAGBIBI',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CAGBUNGA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CALAWAT',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TAMPADONG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'VENERACION (TAGUILID)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ALIANZA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BEBERON',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BOCAL',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BONIFACIO (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUENAVISTA (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CALASCAGAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'COTMO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DACULANG TUBIG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DEL PILAR (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'GNARAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'GRIJALVO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LUPI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MARAGNI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAMUKID',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PINAMASAGAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PIPIAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PLANZA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TAGPOCOL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ADIANGAO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BOCLOD',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CALALAHAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CALAWIT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CATALOTOAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DANLOG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DOLO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'KINALANSAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAMPIRAO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MANZANA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MINORO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PONGLON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PUGAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SALOGON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SOLEDAD (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAGAS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAMBANGAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TELEGRAFO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TOMINAWOG',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'BARAS (POB.)',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'DINAGA (POB.)',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'FUNDADO',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'HARING',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'IQUIN',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'LINAGA',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'MANGAYAWAN',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'PALO',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'PANGPANG (POB.)',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'PORO',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN JOSE EAST',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN JOSE WEST',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'TALIDTID',
    },
    {
        CITY: 'CANAMAN',
        BARANGAY: 'TIBGAO (POB.)',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'AGAAS',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'ANTOLON',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'BACGONG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'BIKAL',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'BINANUAHAN (POB.)',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'CABACONGAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'CADONG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'CANATUAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'CAPUTATAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'COLONGCOGONG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'DARAGA',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'GIBGOS',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'GOGON',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'GUIJALO',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'HANOPOL',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'HANOY',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'HAPONAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'ILAWOD',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'ILI-CENTRO (POB.)',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'LIDONG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'LUBAS',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MALABOG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MAMPIRAO',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MANDICLUM (MANDICLOM)',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MAQUEDA',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'MINALABA',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'ORING',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'OROC-OSOC',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PAGOLINAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PANIMAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PATAG-BELEN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PILI-CENTRO',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'PILI-TABIGUIAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'POLOAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'SOLNOPAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TABGON',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TABIGUIAN',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TABOG',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TAWOG (POB.)',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TEROGO',
    },
    {
        CITY: 'CARAMOAN',
        BARANGAY: 'TOBOAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'CABASAG',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'COMADAYCADAY',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'COMADOGCADOG',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'DOMAGONDONG',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'KINALANGAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'MAGAIS I',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'MAGAIS II',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'MANSALAYA',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'NAGKALIT',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'PALASPAS',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'PAMPLONA',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'PASAY',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'PINAGDAPIAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'PINUGUSAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'POBLACION ZONE III',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SANTA RITA I',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SANTA RITA II',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SINAGAWSAWAN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SINUKNIPAN I',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SINUKNIPAN II',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'SUGSUGIN',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'TABION',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'TOMAGOKTOK',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'ZONE I FATIMA (POB.)',
    },
    {
        CITY: 'DEL-GALLEGO',
        BARANGAY: 'ZONE II SAN ANTONIO (POB.)',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'CAGBUNGA',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'DAHILIG',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'LOOB',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'MALBONG',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'NAMUAT',
    },
    {
        CITY: 'GAINZA',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'ASON (ANSON)',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BINAGASBASAN',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'CAGAMUTAN',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'CAGNIPA',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'CANLONG',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'DANGLA',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'DENRICA',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'HARRISON',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'MANSANGAT',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'PAMBUHAN',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'SUMAOY',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'TAMIAWON',
    },
    {
        CITY: 'GARCHITORENA',
        BARANGAY: 'TOYTOY',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'ABUCAYAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'BAGUMBAYAN GRANDE (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'BAGUMBAYAN PEQUENO (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'BALAYNAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'BELEN (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'CAGAYCAY',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'CATAGBACAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'DIGDIGON',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'GIMAGA',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'HALAWIG-GOGON',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'HIWACLOY',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'LA PURISIMA (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'LAMON',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'MATACLA',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'MAYMATAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'MAYSALAY',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'NAPAWON (NAPUNUON)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'PANDAY (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'PAYATAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'PINAGLABANAN',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SALOG',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN BENITO (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN ISIDRO WEST',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN JUAN BAUTISTA (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN JUAN EVANGELISTA (POB.)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SAN PEDRO (ARORO)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'SCOUT FUENTEBELLA',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'TABGON',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'TAGONGTONG',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'TAMBAN (MABINI)',
    },
    {
        CITY: 'GOA',
        BARANGAY: 'TAYTAY (HALGON EAST)',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'CRISTO REY',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'DEL ROSARIO (BANAO)',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'FRANCIA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'LA ANUNCIACION',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'LA MEDALLA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'LA TRINIDAD',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'NINO JESUS',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'PERPETUAL HELP',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN VICENTE NORTE',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SAN VICENTE SUR',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA CRUZ NORTE',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA CRUZ SUR',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'IRIGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'AGOSAIS',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'AGPO-CAMAGONG-TABOG',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'AMOGUIS',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'BALATON',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'BINANUAHAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'BOCOGAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'CABOTONAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'DAHAT',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'GIMAGTOCON',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'GINORANGAN (GENORANGAN)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'GUBAT',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'GUIBAHOY',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'HIMANAG',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'KINAHOLOGAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'LOHO',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'MANAMOC',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'MANGOGON',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'MAPID',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'OLAS',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'OMALO',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'PANAGAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'PANICUAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'PINAMIHAGAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN ISIDRO NORTE (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN ISIDRO SUR (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SANTA MARIA (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SARIPONGPONG (POB.)',
    },
    {
        CITY: 'LAGONOY',
        BARANGAY: 'SIPACO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'ASLONG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'AWAYAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAGADION',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAGAMELON',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAHAO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BEGAJO NORTE',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BEGAJO SUR',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BEGUITO NUEVO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BEGUITO VIEJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BIKAL',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'BUSAK',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CAIMA',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CALABNIGAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CAMBALIDIO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CANDAMI',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CANDATO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'CUYAPI',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'DANAWAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'DUANG NIOG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'HANDONG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'IBID',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'INALAHAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'LABAO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'LIBOD I',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'LIBOD II',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'LOBA-LOBA',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MALANSAD NUEVO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MALANSAD VIEJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MALBOGON',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MAMBALITE',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MAMBAYAWAS',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MAMBULO NUEVO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MAMBULO VIEJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MANCAWAYAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MANDACANAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'MANTALISAY',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PADLOS',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PAG-ORING NUEVO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PAG-ORING VIEJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PALANGON',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PALONG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PLANZA',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'POTOT',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'PURO-BATIA',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'RONGOS',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SIBUJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'SIGAMOT',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'STATION-CHURCH SITE',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TABAN-FUNDADO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TAMPUHAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TANAG',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TARUM',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TINALMUD NUEVO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TINALMUD VIEJO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'TINANGKIHAN',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'UDOC',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'UMALO',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'USON',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'VILLADIMA (SANTA CRUZ)',
    },
    {
        CITY: 'LIBMANAN',
        BARANGAY: 'VILLASOCORRO',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'ALLEOMAR',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BAGANGAN SR.',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BARRERA JR.',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BARRERA SR.',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BEL-CRUZ',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BELWANG',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BULAWAN JR.',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'BULAWAN SR.',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'CABUTAGAN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'COLACLING (DEL ROSARIO)',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'CRISTO REY',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'HAGUIMIT',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'HALUBAN (PIGBASAGAN)',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'KAIBIGAN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'MANGCAWAYAN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'NAPOLIDAN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'POLANTUNA',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN RAFAEL NORTE',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN RAFAEL SUR',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'SOOC',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'TAPI (LUPI NUEVO)',
    },
    {
        CITY: 'LUPI',
        BARANGAY: 'TIBLE',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'BAROBAYBAY',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'BELL (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'CARANGCANG',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'CARIGSA',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'CASURAY',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'MONSERRAT (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SAN PANTALEON (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'MAGARAO',
        BARANGAY: 'SANTO TOMAS (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'ALIMBUYOG',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'AMPARADO (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'BALAGBAG',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'BORONGBORONGAN',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'CAPUCNASAN',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'DALIPAY',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'DEL ROSARIO (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'FLORDELIZ',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'LIPOT',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'MAYAOPAYAWAN',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'MAYCATMON',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'MAYDASO',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'SANTO DOMINGO (POB.)',
    },
    {
        CITY: 'MILAOR',
        BARANGAY: 'TARUSANAN',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'BAGOLATAO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'BAGONGBONG',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'BALIUAG NUEVO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'BALIUAG VIEJO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'CATANUSAN',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'DEL CARMEN-DEL ROSARIO (POB.)',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'DEL SOCORRO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'HAMORAON',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'HOBO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'IRAYANG SOLONG',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'MAGADAP',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'MALITBOG',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'MANAPAO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'MATAOROC',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAGRADA (SAGRADA FAMILIA)',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SALINGOGON',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAN FELIPE-SANTIAGO (POB.)',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'SAN JUAN-SAN LORENZO (POB.)',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'TABAN',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'TARIRIC',
    },
    {
        CITY: 'MINALABAC',
        BARANGAY: 'TIMBANG',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'ANGUSTIA (ANGUSTIA INAPATAN)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'ANTIPOLO OLD',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'ANTIPOLO YOUNG',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'ARO-ALDAO',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'BUSTRAC',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'DOLOROSA (DOLOROSA INAPATAN)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'DURAN (JESUS DURAN)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'INAPATAN (DEL ROSARIO INAPATAN)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'LA OPINION',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'LA PURISIMA (LA PURISIMA AGUPIT)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'LOURDES OLD',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'LOURDES YOUNG',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'MALAWAG (SAN JOSE MALAWAG)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'PALOYON ORIENTAL',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'PALOYON PROPER (SAGRADA PALOYON)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SALVACION QUE GATOS',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ANTONIO OGBON',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ESTEBAN (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ISIDRO INAPATAN',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN JOSE (SAN JOSE PANGARAON)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN LUIS (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ROQUE MADAWON',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN ROQUE SAGUMAY',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN VICENTE GORONG-GORONG',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SAN VICENTE OGBON',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTA BARBARA (MALIBAN)',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTA ELENA BARAS',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTA LUCIA BARAS',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTIAGO OLD',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTIAGO YOUNG',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'TANDAAY',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'TOPAS PROPER',
    },
    {
        CITY: 'NABUA',
        BARANGAY: 'TOPAS SOGOD',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'AYUGAN',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'CABARIWAN',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'CAGMANABA',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'GATBO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'GUINABAN',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'HANAWAN',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'HIBAGO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'LA PURISIMA NUEVO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'MAY-OGOB',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'NEW MORIONES',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'OLD MORIONES',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'PINIT',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SAN JOSE ORAS',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SAN ROQUE COMMONAL',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'OCAMPO',
        BARANGAY: 'VILLAFLORIDA',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'CARANAN',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'CUCO',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'DALUPAON',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'HUBO',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'ITULAN',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'MACAD (HEBRIO LOURDES)',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'ODICON',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'QUITANG',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'SAN CIRILO (POB.)',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'SANTA ROSA DEL NORTE (POB.)',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'SANTA ROSA DEL SUR (POB.)',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'TILNAC',
    },
    {
        CITY: 'PASACAO',
        BARANGAY: 'TINALMUD',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'ANAYAN',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'BINANWAANAN',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'BINOBONG',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'CADLAN',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'CAROYROYAN',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'CURRY',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'HIMAAO',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'NEW SAN ROQUE',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'OLD SAN ROQUE (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'PALESTINA',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'PAWILI',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAGURONG',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SANTIAGO (POB.)',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'TAGBONG',
    },
    {
        CITY: 'PILI',
        BARANGAY: 'TINANGIS',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'AYUGAO',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BALIGUIAN',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BANTUGAN',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BICALEN',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BITAOGAN',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'CAGNIPA',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'LAGHA',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'LIDONG',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'LIWACSA',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'MAANGAS',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'PATROCINIO',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'SANTA MARIA (POB.)',
    },
    {
        CITY: 'PRESENTACION',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'AGAO-AO',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'AGRUPACION',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'AMOMOKPOK',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'APAD',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'APALE',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'BANGA CAVES',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'BAYA',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'BINAHAN PROPER',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'BINAHAN UPPER',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CABADISAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CABINITAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CADITAAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CALE',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'CATABANGAN PROPER',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'F. SIMEON (PUGOD)',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'GODOFREDO REYES SR. (CATABANGAN CROSSING)',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'INANDAWA',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LAGUIO',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LANIPGA-CAWAYAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LIBORO',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LOHONG',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LOWER OMON',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'LOWER SANTA CRUZ',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'PANAYTAYAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'PANAYTAYAN NUEVO',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'PATALUNAN',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'POBLACION ILAOD',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'POBLACION IRAYA',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'PORT JUNCTION NORTE',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'PORT JUNCTION SUR',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'SAMAY',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'TAGBAC',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'UPPER OMON',
    },
    {
        CITY: 'RAGAY',
        BARANGAY: 'UPPER SANTA CRUZ',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'ANIOG',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'ATULAYAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'BONGALON',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'BURACAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'CATALOTOAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'KILANTAAO',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'KILOMAON',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'MABCA',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'MINADONGJOL',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'PATITINAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'SIBAGUAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'TINORONGAN',
    },
    {
        CITY: 'SAGNAY',
        BARANGAY: 'TURAGUE',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'ALDEZAR',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'ALTEZA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'ANIB',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'AWAYAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'AZUCENA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BINAHIAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BOLO NORTE',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BOLO SUR',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BULAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'CABUYAO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'CAIMA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'CALAGBANGAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'CALAMPINAY',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'CARAYRAYAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'COTMO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'GAONGAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'IMPIG',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'LIPILIP',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'LUBIGAN JR.',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'LUBIGAN SR.',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MALAGUICO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MALUBAGO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MANANGLE',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MANGAPO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MANLUBANG',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'MANTILA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'NORTH CENTRO (POB.)',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'NORTH VILLAZAR',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SALANDA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SERRANZANA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SOUTH CENTRO (POB.)',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'SOUTH VILLAZAR',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'TAISAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'TARA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'TIBLE',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'TULA-TULA',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'VIGAAN',
    },
    {
        CITY: 'SIPOCOT',
        BARANGAY: 'YABO',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'BAHAO',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'BOBOAN',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'BUTAWANAN',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'FUNDADO',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'HOMESTEAD',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'MALACONINI',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'MATANDANG SIRUMA',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'NALAYAHAN',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'PAMINTAN-BANTILAN',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'PINITAN',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'SAN RAMON (DALDAGON)',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'SULPA',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'TANDOC',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'TONGO-BANTIGUE',
    },
    {
        CITY: 'SIRUMA',
        BARANGAY: 'VITO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'ABO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'CABALINADAN',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'CARAYCAYON',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'CASUNA',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'CONSOCEP',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'COYAOYAO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'GAAO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'GINGAROY',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'GUBAT',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'HUYONHUYON',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'LIBOD',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'MABALODBALOD',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'MAY-ANAO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'PANAGAN',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'TALOJONGON',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'TINAWAGAN',
    },
    {
        CITY: 'TIGAON',
        BARANGAY: 'VINAGRE',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'AGAY-AYAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BATAAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BINALAY',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BOLAOBALITE',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'CAGLILIOG',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'CALOCO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'CANAYONAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'CAWAYNAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'DALIGAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'FILARCA (POB.)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'LA MEDALLA (MILE 9)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'LA PURISIMA (POB.)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'LUPI',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'MAGSAYSAY (CAMP 4)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'MAGTANG',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'MANANAO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'NEW CAALUAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'OLAG GRANDE',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'OLAG PEQUENO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'OLD CAALUAN',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'PANTAT',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAGRADA (CAMP 6)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SALVACION POBLACION',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN JOSE (TILTILAN)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN PASCUAL (POB.)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN RAMON (CAMP 7)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'SOGOD',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'TAMBANG',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'TIERRA NEVADA',
    },
    {
        CITY: 'TINAMBAC',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'BACAK',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'BAGATABAO',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'BUGAO',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'CAHAN',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'HINIPAAN',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'QUEZON (PANCAYANAN)',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'QUIGARAY',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SALVACION (PANUTO)',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SAN RAFAEL (MAHANTOD)',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SANTA MESA',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'BAGAMANOC',
        BARANGAY: 'SUCHAN',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'BOCON',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'BOTHOAN (POB.)',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'CAMBURO',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'DARIAO',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'DATAG EAST',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'DATAG WEST',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'GUIAMLONG',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'HITOMA',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'ICANBATO (POB.)',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'INALMASINAN',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'IYAO',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'MAUI',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'MAYSURAN',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'MILAVIGA',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'OBI',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'PANIQUE',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'SABLOYON',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'SUPANG',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'TOYTOY (POB.)',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'TUBLI',
    },
    {
        CITY: 'CARAMORAN',
        BARANGAY: 'TUCAO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'ABIHAO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'AGBAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'BATOLINAO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'BENTICAYAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'CARAGUMIHAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'EASTERN POBLACION',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'GINITLIGAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'GUINSAANAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'J. M. ALBERTO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'MACUTAL',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'MONING',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'NAGBARORONG',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'P. TESTON',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'PANIQUIHAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'PURARAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'PUTSAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'TILOD',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'WESTERN POBLACION',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'AROYAO PEQUENO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BANAWANG',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BATALAY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BINANUAHAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BINANWAHAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BOTE',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CAGRARAY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CARORIAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'GUINOBATAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'ILAWOD (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'LIBOD POBLACION',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MARINAWA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MINTAY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'OGUIS',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PANANAOGAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SIBACUNGAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SIPI',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TAMBURAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TILIS',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'AGOJO',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'ALIBUAG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'ASGAD (JUAN M. ALBERTO)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BARIHAY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BATONG PALOWAY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BELMONTE (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BISLIG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'BON-OT',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CABCAB',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CARANGAG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CATAGBACAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CODON',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'COMAGAYCAY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'DIVINO ROSTRO (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'ESPERANZA (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'HILAWAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'LICTIN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'LUBAS',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MANAMBRAG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MAYNGAWAY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'PALAWIG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'PUTING BAYBAY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SALVACION (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'SAPANG PALAY (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TIBANG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TIMBAAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TOMINAWOG',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'WAGDAS (POB.)',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'YOCTI',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'ATSAN (DISTRICT I)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BALATOHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BOTON',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BUHI',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'DAYAWA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'J. M. ALBERTO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'KILIKILIHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'OBO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PACOGON',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PANGILAO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION DISTRICT II',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION DISTRICT III',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SALVACION (PATAGAN)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN JUAN (AROYAO)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA ELENA (PATAGAN)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SIAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SOLONG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TOBREHON',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'BIONG',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'DORORIAN',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'POBLACION DISTRICT I',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'POBLACION DISTRICT II',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'POBLACION DISTRICT III',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'SICMIL',
    },
    {
        CITY: 'GIGMOTO',
        BARANGAY: 'SIORON',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BAGAWANG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BALAGNONAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BALDOC',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CANLUBI',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CATAMBAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'COBO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'HIYOP',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'LIBOD (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'LUMABAO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'MARAMBONG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'NAPO (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'OGA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'PANDAN DEL NORTE (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'PANDAN DEL SUR (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'PANUTO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'POROT (SAN JOSE)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SALVACION (TARIWARA)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN ANDRES (DINUNGSURAN)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN ISIDRO (LANGOB)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN RAFAEL (BOGTONG)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SANTA CRUZ (CATAGBACAN)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'TABUGOC',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'TOKIO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'WAGDAS',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'ALINAWAN',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'BABAGUAN',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'BAGONG BAYAN',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'CABUYOAN',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'CAGDARAO',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'MACULIW',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'PANAY',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SALVACION (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN JOAQUIN (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SANTA ANA (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SANTA MARIA (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'SANTO SANTIAGO (POB.)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'TAOPON (PANGCAYANAN)',
    },
    {
        CITY: 'PANGANIBAN',
        BARANGAY: 'TIBO',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'ALMOJUELA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'ANANONG',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'ASUNCION (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'BATOHONAN',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'BEGONIA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'BOTINAGAN',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'OGBONG',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'PEDRO VERA (SUMMIT)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'PENAFRANCIA (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'QUIRINO (ABUGAN)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN JOSE OCO',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN JOSE POBLACION',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'SOBOC',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'TAMBONGON',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'VIGA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'ANTIPOLO DEL NORTE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'ANTIPOLO DEL SUR',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'BATAG',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'BIGAA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CABIHIAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CALABNIGAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CALAMPONG',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CALATAGAN PROPER',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CALATAGAN TIBANG',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CAPILIHAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CASOOCAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CAVINITAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CONCEPCION (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'CONSTANTINO (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'DANICOP',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'DUGUI SAN ISIDRO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'DUGUI SAN VICENTE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'DUGUI TOO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'F. TACORDA VILLAGE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'FRANCIA (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'GOGON CENTRO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'GOGON SIRANGAN',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'HAWAN GRANDE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'HAWAN ILAYA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'HICMING',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'IBONG SAPA (SAN VICENTE SUR)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'JUAN M. ALBERTO (PONITON)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'LANAO (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'MAGNESIA DEL NORTE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'MAGNESIA DEL SUR',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'MARCELO ALBERTO (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'MARILIMA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PAJO BAGUIO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PAJO SAN ISIDRO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PALNAB DEL NORTE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PALNAB DEL SUR',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PALTA BIG',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PALTA SALVACION',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'PALTA SMALL',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'RAWIS (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN ISIDRO VILLAGE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN PABLO (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SANTA ELENA (POB.)',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SIMAMLA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SOGOD-SIMAMLA',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'SOGOD-TIBGAO',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'TALISOY',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'TUBAON',
    },
    {
        CITY: 'VIRAC',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'BANGATE',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'BUGTONG',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'CAGANG',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'JIBONG',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'LAGO',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'LAYOG',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'LUNETA',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'MACABARI',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'MAPAPAC',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'OLANDIA',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'PAGHALUBAN',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'PUTIAO',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'SANTA LOURDES',
    },
    {
        CITY: 'BARCELONA',
        BARANGAY: 'TAGDON',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'A. BONIFACIO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ABAD SANTOS',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'BEGUIN',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'BENIGNO S. AQUINO (IMELDA)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'BUTAG',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'CADANDANAN',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'CALOMAGON',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'CALPI',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'COCOK-CABITAN',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'DAGANAS',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'DOLOS',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'E. QUIRINO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'G. DEL PILAR (TANGA)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'GATE',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'INARARAN',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'J. GERONA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'J.P. LAUREL (PON-OD)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'JAMORAWON',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'LAJONG',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'M. ROXAS',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'MANAGANAGA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'MARINAB',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'MONTECALVARIO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'N. ROQUE (RIZAL)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'NAMO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'NASUJE',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'OBRERO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'OTAVI',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'PADRE DIAZ',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'R. GERONA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'RECTO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN JUAN BAG-O',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN JUAN DAAN',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SANTA REMEDIOS',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SIGAD',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'SOMAGONGSONG',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'TAROMATA',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE I POB. (BGY. 1- SOUTH ILAWOD)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE II POB. (BGY. 2- WEST ILAWOD)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE III POB. (BGY. 3- EAST ILAWOD)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE IV POB. (BGY. 4- WEST CENTRAL)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE V POB. (BGY. 5-LANIPAN)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE VI POB. (BGY. 6- BAYBAY)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE VII POB. (BGY. 7- IRAYA)',
    },
    {
        CITY: 'BULAN',
        BARANGAY: 'ZONE VIII POB. (BGY. 8- LOYO)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'DANCALAN',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'DAPDAP (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'LALUD',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'LOOBAN (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'MABUHAY (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'MADLAWON (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'POCTOL (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'POROG',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SABANG (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN BERNARDO',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAN VICENTE (BUHANG)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'SAPNGAN (POB.)',
    },
    {
        CITY: 'BULUSAN',
        BARANGAY: 'TINAMPO',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'AMOMONTING',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'BAGALAYAG',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'BAGONG SIRANG',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'CABURACAN',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'CANJELA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'CUMADCAD',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'DANGCALAN',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'DINAPA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'LORETO',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MACALAYA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MARACABAC',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MAYON',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MAYPANGI',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MILUYA',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'MONTE CARMELO',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'ORAS',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'QUIRAPI',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SACLAYAN',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'SOGOY',
    },
    {
        CITY: 'CASTILLA',
        BARANGAY: 'TOMALAYTAY',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'ALIN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'AWAI',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BANDI',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BANUANG GURANG',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BAYAWAS',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'BORORAN BARANGAY 1 (POB.)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'CENTRAL BARANGAY 2 (POB.)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'CRISTO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'DANCALAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'DE VERA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'GIMAGAAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'GIRAWAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'GOGON',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'GURA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'JUAN ADRE',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'MALAPOC',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'MARKET SITE BARANGAY 3 (POB.)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'NEW MAGUISA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'OGOD (CROSSING)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'OLD MAGUISA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'ORANGE',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'PARINA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'PAWALA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'PINAMANAAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'POSO POB. (BARANGAY 5)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'PUNTA WALING-WALING POB. (BARANGAY 4)',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SEVILLA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SIBAGO',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'SUGUIAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TAGBAC',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TINANOGAN',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TONGDOL',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TRES MARIAS',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TUBA',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'DONSOL',
        BARANGAY: 'VINISITAHAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'ARIMAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BALUD DEL NORTE (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BALUD DEL SUR (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BENGUET',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BENTUCO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BERIRAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'BULACAO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'CABIGAAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'CABIGUHAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'CARRIEDO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'COTA NA DACO (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'JUPI',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'LAPINIG',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'LUNA-CANDOL (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'MANAPAO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'MANOOK (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'NAAGTAN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'NAZARENO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'OGAO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PANGANIBAN (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PARADIJON (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PAYAWIN',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'PINONTINGAN (POB.)',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'SANGAT',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'TABI',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'TIGKIW',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'TIRIS',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'TOGAWE',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'GUBAT',
        BARANGAY: 'VILLAREAL',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BACOLOD (POB.)',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BAGSANGAN',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BOLOS',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'CARRIEDO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'CASINI',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'GABAO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'GULANG-GULANG',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'GUMAPIA',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'LIANG',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'MACAWAYAN',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'MAPASO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'MONBON',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SAN JULIAN (POB.)',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'SANTO DOMINGO (LAMBOON)',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'TABON-TABON',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'TINAMPO',
    },
    {
        CITY: 'IROSIN',
        BARANGAY: 'TONGDOL',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'ANOG',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'AROROY',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'BINANUAHAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'BIRIRAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'BURABURAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'CALATEO',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'CALMAYON',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'CAROHAYON',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'CATANAGAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'CATANUSAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'EMBARCADERO',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'GURUYAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'LAJONG',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'MAALO',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'PUTING SAPA',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'RANGAS',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'SABLAYAN',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'SIPAYA',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'JUBAN',
        BARANGAY: 'TUGHAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BALOCAWE',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BANOGAO',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BANUANGDAAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BARIIS',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BON-OT BIG',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'BON-OT SMALL',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CABAGAHAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CALAYUAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CALINTAAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CALOOCAN (POB.)',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CALPI',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CAMACHILES (POB.)',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CAMCAMAN (POB.)',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CORON-CORON',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'GADGARON',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'GENABLAN OCCIDENTAL',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'GENABLAN ORIENTAL',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'HIDHID',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'LABOY',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'LAJONG',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'MAMBAJOG',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'MANJUNLAD',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'MANURABI',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'NABURACAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'PAGHULIRAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'POROPANDAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SINALMACAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SINANG-ATAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SINIBARAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SISIGON',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'SULANGAN',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'TABLAC (POB.)',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'TABUNAN (POB.)',
    },
    {
        CITY: 'MATNOG',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'BRILLANTE (POB.)',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'CALAO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'CARAYAT',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'DIAMANTE',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'GOGON',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'LUPI',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'MANINGCAY DE ORO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'MANLABONG',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'PERLAS',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'QUIDOLOG',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SANTA LOURDES',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'TALISAYAN',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'TUPAZ',
    },
    {
        CITY: 'PRIETO-DIAZ',
        BARANGAY: 'ULAG',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'BARANGAY POBLACION I',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'BARANGAY POBLACION II',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'BARANGAY POBLACION III',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'BARANGAY POBLACION IV',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN BARTOLOME (TALAONGAN)',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN EUGENIO',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-MAGDALENA',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'ADOVIS (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BOTON',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'COLAMBIS',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'ESCUALA',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'INLAGADIAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'LUNGIB',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SAN ANTONIO (BOHO)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'SOMAL-OT (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TIMBAYOG (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TIRIS',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TRECE MARTIREZ',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'ABUYOG',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'ALMENDRAS-COGON (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BALOGO (BACON DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BALOGO (SORSOGON EAST DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BIBINCAHAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BITAN-O/DALIPAY (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BOGNA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BON-OT',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BUCALBUCALAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BUENAVISTA (BACON DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BUENAVISTA (SORSOGON WEST DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BUHATAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BULABOG',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'BURABOD (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'CABARBUHAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'CABID-AN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'CAMBULAGA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'CAPUY',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'CARICARAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'GATBO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'GIMALOTO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'GUINLAJON',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'JAMISLAGAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'MACABOG',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'MARICRUM',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'MARINAS',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'OSIAO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'PAMURAYAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'PANLAYAAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'PIOT (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'POLVORISTA (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SALOG (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SALVACION (BACON DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SALVACION (SORSOGON WEST DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAMPALOC (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN ISIDRO (BACON DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN ISIDRO (SORSOGON WEST DISTRICT)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN JUAN (RORO)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SAWANGA',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SIRANGAN (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'SULUCAN (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'TALISAY (POB.)',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'TICOL',
    },
    {
        CITY: 'SORSOGON',
        BARANGAY: 'TUGOS',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'AGUADA NORTE',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'AGUADA SUR',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'ANIBONG',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BACALON',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BANACUD',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BEHIA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BINISITAHAN DEL NORTE',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BINISITAHAN DEL SUR',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BITON',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CADITAAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CAGBOLO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CAGTALABA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CAWIT EXTENSION',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CAWIT PROPER',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'GINANGRA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'HUBO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'INCARIZAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'LAPINIG',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'PANTALAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'PAWIK',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SIUTON',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'TAGAS',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'TULATULA NORTE',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'TULATULA SUR',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ABAS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ABUCAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BANUYO (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAYASONG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAYAWAS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BINANUAHAN (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CABIGUAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CAGDONGON',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CALONGAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CALPI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CATAMLANGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'COMAPO-CAPO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DANLOG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DAO (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DEL ROSARIO (BUAL)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ESMERADA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'GINABLAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'GUIRON',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'INANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'INAPUGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LEONA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LIPASON',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LUBIANO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LUNGIB',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MABANATE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MARIFOSQUE (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MIGABOD',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NASPI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PINAGSALOG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PINEDA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'POCTOL',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PUDO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PUTIAO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SACNANGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ANTONIO (MILLABAS)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ANTONIO (SAPA)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SANTA FE',
    }
];
